import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AccessRequestNodeFragment = { __typename?: 'AccessRequest', id?: string | null, requestedAt?: string | null, hasAccountUser?: boolean | null, hasMemberLicense?: boolean | null, requestedResource?: { __typename?: 'Collection', id: string, name: string, collectionProject: { __typename?: 'Project', id: string, name: string } } | { __typename?: 'FileAsset', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'FolderAsset', id: string, name: string, folderAssetProject?: { __typename?: 'Project', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'Project', id: string, name: string } | { __typename?: 'VersionStackAsset', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null } | null, requesterUser?: { __typename?: 'UserInfo', id: string, email: string, name?: string | null, profileImageUrl?: string | null, avatarColor?: Types.AvatarColor | null } | null };

export const AccessRequestNode = /*#__PURE__*/ gql`
    fragment AccessRequestNode on AccessRequest {
  id
  requestedResource {
    ... on Project {
      id
      name
    }
    ... on FolderAsset {
      id
      name
      folderAssetProject: project {
        id
        name
      }
    }
    ... on Collection {
      id
      name
      collectionProject: project {
        id
        name
      }
    }
    ... on Asset {
      id
      name
      project {
        id
        name
      }
    }
  }
  requesterUser: requesterUserInfo {
    id
    email
    name
    profileImageUrl
    avatarColor
  }
  requestedAt
  hasAccountUser
  hasMemberLicense
}
    ` as unknown as DocumentNode<AccessRequestNodeFragment, unknown>;

        

        
export const useAccessRequestNodeFragment = (
  input: string | Omit<UseFragmentOptions<AccessRequestNodeFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AccessRequest' } };
    return input;
  })();

  return useFragment<AccessRequestNodeFragment>({
    fragment: AccessRequestNode,
    fragmentName: 'AccessRequestNode',
    ...options,
  });
};
  
        